import { useEffect, useState } from 'react';
import useBackendApi from './useBackendApi';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

const useDownloadResult = (url: string, testName: string, sampleId: string) => {
  const { apiFetchRequest } = useBackendApi();
  const [userResultData, setUserResultData] = useState<any>();
  const [error, setError] = useState<any>('');
  const [isResultDownloading, setIsResultDownloading] = useState<boolean>(true);
  const { addAlertMessages } = useThemeContext();

  useEffect(() => {
    const handleFetchReportPdfById = async () => {
      try {
        setIsResultDownloading(true);
        setError('');
        const data = await apiFetchRequest({
          endpoint: url,
        });

        if (data.status === 500) {
          addAlertMessages({ message: 'Error while fetching PDF', severityType: 'error' });
          setError('a server error occurred');
          setIsResultDownloading(false);
          return;
        }
        setUserResultData(data.body.report_pdf_data);

        setIsResultDownloading(false);
      } catch (exception) {
        setError(exception instanceof Error ? exception.message : 'An unknown error occurred');
        console.log('Error fetching user result:', exception);
      }
    };

    handleFetchReportPdfById();
  }, [url]);

  const handleDownloadClick = () => {
    try {
      if (!userResultData) {
        setError('PDF data not found for this report.');
      } else {
        const binary = atob(userResultData);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          array[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([array], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        let test_name = testName.replace(/ /g, '_');
        link.download = `${test_name}_${sampleId}.pdf`; // filename

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (exception) {
      setError(exception instanceof Error ? exception.message : 'An unknown error occurred');
      console.log('Error fetching user result:', exception);
    }
  };

  return { handleDownloadClick, isResultDownloading, error, userResultData };
};

export default useDownloadResult;
